import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageSlideBaseComponent } from '@luggagehero/features/ui';

@Component({
  selector: 'lh-image-slide',
  templateUrl: './image-slide.component.html',
  styleUrls: ['./image-slide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ImageSlideComponent extends ImageSlideBaseComponent {}
